"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Unit = exports.decodeUnit = exports.ProductType = exports.DeviceType = void 0;

var uuid_1 = require("./support/uuid");

var connection_1 = require("./connection");

var location_1 = require("./location");

var status_1 = require("./status");

var meter_1 = __importStar(require("./meter"));

var modem_1 = require("./modem");

var ports_1 = __importStar(require("./ports"));

var health_1 = require("./health");

var scheduling_1 = __importDefault(require("./scheduling"));

var weather_1 = require("./weather");

var workorder_1 = require("./workorder");

var alert_1 = require("./alert");

var sla_1 = require("./sla");

var unit_1 = require("./storage/unit");

var unit_2 = __importStar(require("./http/unit"));

var alert_2 = require("./http/alert");

var alarm_1 = require("./http/alarm");

var alarm_2 = require("./alarm");

var configuration_1 = require("./configuration");

var model_1 = require("./model");

var DeviceType;

(function (DeviceType) {
  DeviceType[DeviceType["Root"] = -1] = "Root";
  DeviceType[DeviceType["Unknown"] = 0] = "Unknown";
  DeviceType[DeviceType["Asset"] = 1] = "Asset";
  DeviceType[DeviceType["Meter"] = 2] = "Meter";
  DeviceType[DeviceType["UsagePoint"] = 3] = "UsagePoint";
  DeviceType[DeviceType["Logging"] = 4] = "Logging";
  DeviceType[DeviceType["NonLogging"] = 5] = "NonLogging";
  DeviceType[DeviceType["Pushing"] = 6] = "Pushing";
  DeviceType[DeviceType["Virtual"] = 8] = "Virtual";
})(DeviceType = exports.DeviceType || (exports.DeviceType = {}));

var ProductType;

(function (ProductType) {
  ProductType[ProductType["Unknown"] = 0] = "Unknown";
  ProductType[ProductType["Zodiac"] = 1] = "Zodiac";
  ProductType[ProductType["Oculus"] = 2] = "Oculus";
  ProductType[ProductType["Gemini"] = 3] = "Gemini";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
/**
 * decodeUnit decodes API-formatted units into Unit objects and properly initializes them
 * @param u a raw API-formatted unit to be parsed into a Unit
 */


exports.decodeUnit = function (u) {
  var e_1, _a;

  var uuid;

  if (typeof u.uuid === "string") {
    uuid = new uuid_1.UUID(u.uuid);
  } else {
    uuid = new uuid_1.UUID(u.uuid._uuid);
  }

  var unit = new Unit(uuid, u.assetid, u.giai, u.model, u.version, u.channel, new Date(u.time), new Date(u.lastseen), u.profile, u.profileversion, u.deviceType);

  if (u.lastSeen) {
    unit.lastSeen = u.lastSeen;
  }

  unit.model = model_1.decodeModel(u.model);

  if (unit.model.manufacturer === "") {
    if (u.model2 != null) {
      var m = model_1.decodeModel(u.model2);

      if (m.manufacturer !== "") {
        unit.model = m;
      }
    }
  }

  if (u.location) {
    unit.location = location_1.decodeLocation(u.location);
  }

  if (u.weather) {
    unit.weather = weather_1.decodeWeather(u.weather);
  }

  if (u.ports && u.ports.length > 0) {
    if (u.ports._ports && u.ports._ports.length === u.ports.length) {
      unit.ports = ports_1.decodePorts(u.ports._ports);
    } else {
      unit.ports = ports_1.decodePorts(u.ports);
    }
  }

  if (u.virtualPorts && u.virtualPorts.length > 0) {
    var vPorts = ports_1.decodePorts(u.virtualPorts);

    try {
      for (var _b = __values(vPorts.ports()), _c = _b.next(); !_c.done; _c = _b.next()) {
        var p = _c.value;
        unit.ports.push(p);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  }

  if (u.meter) {
    unit.meters = [meter_1.decodeMeter(u.meter)];
  }

  if (u.meters) {
    unit.meters = [meter_1.decodeMeter(u.meters[0])];
  }

  if (u.modem) {
    unit.modem = modem_1.decodeModem(u.modem);
  }

  if (u.connections && u.connections.length > 0) {
    unit.connections = connection_1.decodeConnections(u.connections);
  }

  if (u.configurations && u.configurations.length > 0) {
    unit.configurations = u.configurations.map(function (c) {
      return configuration_1.decodeConfiguration(c);
    });
  }

  if (u.scheduling) {
    unit.scheduling = new scheduling_1.default(u.scheduling.method, u.scheduling.priority, u.scheduling.system, u.scheduling.data);
  }

  if (u.sla) {
    unit.sla = new sla_1.SLA(u.sla.dataToday, u.sla.dataYesterday);
  }

  if (u.oldSLA) {
    unit.oldSLA = u.oldSLA;
  }

  if (u.status) {
    if (u.status.status) {
      unit.status = new status_1.Status(u.status.status, u.status.time);
    } else if (u.status.state) {
      unit.status = new status_1.Status(u.status.state, u.status.time);
    }
  }

  if (u.lifecycle) {
    if (u.lifecycle.status) {
      unit.lifecycle = new status_1.Status(u.lifecycle.status, u.lifecycle.time);
    } else if (u.lifecycle.state) {
      unit.lifecycle = new status_1.Status(u.lifecycle.state, u.lifecycle.time);
    }
  }

  if (u.workorders && u.workorders.length > 0) {
    unit.workorders = workorder_1.decodeWorkOrders(u.workorders);
  }

  return unit;
};
/**
   A Unit is the main resource in Corona, it holds a device or resource which
   has a unique identifier.
 */


var Unit =
/** @class */
function () {
  /**
   * Create a new Unit
   * @param uuid - The UUID of the unit
   */
  function Unit(uuid, assetid, giai, model, version, channel, time, lastSeen, profile, profileversion, deviceType, location, status, lifecycle, modem) {
    if (assetid === void 0) {
      assetid = '';
    }

    if (giai === void 0) {
      giai = '';
    }

    if (model === void 0) {
      model = new model_1.Model('', '', '', model_1.Medium.Other, 0);
    }

    if (version === void 0) {
      version = '';
    }

    if (channel === void 0) {
      channel = '';
    }

    if (profile === void 0) {
      profile = 0;
    }

    if (profileversion === void 0) {
      profileversion = 0;
    }

    if (deviceType === void 0) {
      deviceType = 0;
    }

    if (status === void 0) {
      status = new status_1.Status("unknown", "0");
    }

    if (lifecycle === void 0) {
      lifecycle = new status_1.Status("unknown", "0");
    }

    if (modem === void 0) {
      modem = new modem_1.Modem();
    }

    var yearZero = new Date(); // Since dawn of time the fate of man is that of lice

    yearZero.setTime(0); // Equal as parasites and moving without eyes

    this.uuid = uuid;
    /*this.mac = "";
    if (mac) {
      this.mac = mac;
    }*/

    this.assetid = assetid;
    this.giai = giai;
    this.model = model;
    this.version = version;
    this.channel = channel;
    this.time = yearZero;

    if (time) {
      this.time = time;
    }

    this.lastSeen = yearZero;

    if (lastSeen) {
      this.lastSeen = lastSeen;
    }

    this.profile = profile;
    this.profileVersion = profileversion;
    this.deviceType = deviceType;
    this.lastUpdated = yearZero;
    this.location = new location_1.UnitLocation('', '', 0, 0, '', '', '', '', '', '', '', '', '');

    if (location) {
      this.location = location;
    }

    this.status = status;
    this.lifecycle = lifecycle;
    this.meters = [new meter_1.default("")];
    this.modem = modem;
    this.connections = [];
    this.configurations = [];
    this.ports = new ports_1.default([]);
    this.weather = new weather_1.Weather(yearZero, 0, '', 0, 0, 0, 0);
    this.workorders = [];
    this.connectable = false;
    this.scheduling = new scheduling_1.default(0, -1, 0, {});
    this.fields = [];
    this.sla = new sla_1.SLA(0, 0);
  }

  Unit.prototype.productType = function () {
    if (this.model.model.substr(0, 2) === "Z3") {
      return ProductType.Zodiac;
    }

    if (this.model.model.substr(0, 2) === "O3") {
      return ProductType.Oculus;
    }

    if (this.model.model.substr(0, 2) === "G3") {
      return ProductType.Gemini;
    }

    return ProductType.Unknown;
  };

  Unit.prototype.deviceTypeString = function () {
    if (this.deviceType === DeviceType.Root) {
      return "Grid root";
    }

    if (this.deviceType === DeviceType.Asset) {
      return "Misc asset";
    }

    if (this.deviceType === DeviceType.Meter) {
      return "Meter";
    }

    if (this.deviceType === DeviceType.UsagePoint) {
      return "Usage point location";
    }

    if (this.deviceType === DeviceType.Logging) {
      return "Communication Device";
    }

    if (this.deviceType === DeviceType.NonLogging) {
      return "Communication Device";
    }

    if (this.deviceType === DeviceType.Pushing) {
      return "Communication Device";
    }

    return "Unknown";
  };

  Unit.prototype.tags = function () {
    if (this.location != null) {
      return this.location.tokenizeName();
    }

    return [];
  };
  /** Replace merges and updates storage for a given unit */


  Unit.prototype.replace = function (u, store) {
    if (store === void 0) {
      store = true;
    }

    this.merge(u);

    if (store) {
      this.store();
    }
  }; // calculate old sla

  /* Public: Calculates SLA for a given unit and updates the unit object
   *  unit - a Unit to calculate the data and connectivity SLA for
   */


  Unit.prototype.calculateOldSLA = function (partial) {
    var e_2, _a, e_3, _b;

    var sla = {
      full: "ok",
      short: "ok",
      data_today: 0.0,
      data_yesterday: 0.0,
      communication_today: 0.0,
      communication_yesterday: 0.0,
      parameters: {}
    }; // Dont calculate SLA for install locations

    if (this.deviceType != null && this.deviceType === DeviceType.UsagePoint) {
      sla.full = 'disable';
      sla.short = 'disable';
      return sla;
    } // Dont calculate SLA for install locations


    if (this.deviceType != null && this.deviceType === DeviceType.Virtual) {
      sla.full = 'ok';
      sla.short = 'ok';
      return sla;
    } // Dont calculate SLA for devices which aren't in operation


    if (this.status.isSLADisabled()) {
      sla.full = 'disable';
      sla.short = 'disable';
      return sla;
    }

    if (partial) {
      sla.full = 'ok';
      sla.short = 'ok';
      return sla;
    }

    if (this.status.isTesting()) {
      sla.full = 'ok';
      sla.short = 'ok';

      if (this.status.state === status_1.StatusState.FactoryTest) {
        if (this.workorders) {
          try {
            for (var _c = __values(this.workorders), _d = _c.next(); !_d.done; _d = _c.next()) {
              var wo = _d.value;

              if (wo.type === 16 || wo.type === 18) {
                if (wo.state === 0) {
                  sla.full = 'error';
                  sla.short = 'error';
                }
              }
            }
          } catch (e_2_1) {
            e_2 = {
              error: e_2_1
            };
          } finally {
            try {
              if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally {
              if (e_2) throw e_2.error;
            }
          }
        } else {
          sla.full = 'warning';
          sla.short = 'warning';
        }
      } else if (this.status.state === status_1.StatusState.PowerUpTest) {
        if (this.workorders) {
          try {
            for (var _e = __values(this.workorders), _f = _e.next(); !_f.done; _f = _e.next()) {
              var wo = _f.value;

              if (wo.type === 15) {
                if (wo.state === 0) {
                  sla.full = 'error';
                  sla.short = 'error';
                }
              }
            }
          } catch (e_3_1) {
            e_3 = {
              error: e_3_1
            };
          } finally {
            try {
              if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
            } finally {
              if (e_3) throw e_3.error;
            }
          }
        } else {
          sla.full = 'warning';
          sla.short = 'warning';
        }
      }

      return sla;
    } // actual calculations start here


    sla = this.ports.calculateOldSLA(); // COMMUNICATION SLA
    // some constants
    // Today and yesterday timepoints (in UTC)

    var utcToday = new Date();
    utcToday.setUTCHours(0);
    utcToday.setUTCMinutes(0);
    utcToday.setUTCSeconds(0);
    utcToday.setUTCMilliseconds(0);
    var utcYesterday = new Date(utcToday.valueOf()); // because assign of date is by ref in JS

    utcYesterday.setUTCDate(utcYesterday.getUTCDate() - 1);
    var lastSeenToday = this.lastSeen.getTime() - utcToday.getTime();
    var lastComToday = this.status.time.getTime() - utcToday.getTime();
    var lastSeenYesterday = this.lastSeen.getTime() - utcYesterday.getTime();
    var lastComYesterday = this.status.time.getTime() - utcYesterday.getTime();
    var sinceLastSeen = new Date().getTime() - this.lastSeen.getTime();
    var schedulingInterval = this.scheduling && this.scheduling.data && this.scheduling.data.interval ? this.scheduling.data.interval * 1000 : 1800000;
    var schedulingIntervalsToday = (new Date().getTime() - utcToday.getTime()) / schedulingInterval;

    if (lastSeenToday < 0) {
      sla.communication_today = 0.00;

      if (lastSeenYesterday < 0) {
        sla.communication_yesterday = 0.00;
      } else {
        sla.communication_yesterday = lastSeenYesterday / lastComYesterday * 100;

        if (sla.communication_yesterday < 0.0) {
          sla.communication_yesterday = 0.0;
        }

        ;
      }
    } else {
      sla.communication_today = lastSeenToday / lastComToday * 100;
      sla.communication_yesterday = 100.00;
    } // We are not expecting to have communicated with the device yet today


    if (schedulingIntervalsToday < 1.0) {
      sla.communication_today = 100.00; // less than one half of a scheduling for today means that we have more than two days of scheduling interval so we might not have connected yesterday

      if (schedulingIntervalsToday < 0.5) {
        sla.communication_yesterday = 100.00;
      }
    } else {
      if (lastSeenToday > 0) {
        sla.communication_today = 100.00;

        if (sinceLastSeen > schedulingInterval * 2) {
          sla.communication_today = (1 - sinceLastSeen / schedulingInterval / schedulingIntervalsToday) * 100;

          if (sla.communication_today < 0.0) {
            sla.communication_today = 0.0;
          }

          ;
        }
      }
    } // add SLA classes


    sla.full = 'ok';
    sla.short = 'ok'; // Sched intervals today of less than 0.5 means that we dont expect data every other day

    if ((sla.data_yesterday === 0.0 && sla.data_today === 0.0 || sla.communication_yesterday === 0.0 && sla.communication_today === 0.0) && schedulingIntervalsToday >= 0.5) {
      sla.full = 'error';
    } else if ((sla.data_yesterday < 100.0 && sla.data_today === 0.0 || sla.communication_yesterday < 100.0 && sla.communication_today === 0.0) && schedulingIntervalsToday >= 0.5) {
      sla.full = 'warning';
    } // Sched intervals today of less than 1 means that we dont expect data every day


    if (schedulingIntervalsToday > 1.0) {
      if (sla.data_today === 0.0 && sla.communication_today === 0.0) {
        sla.short = 'error';
      } else if (sla.data_today === 0.0 || sla.communication_today === 0.0) {
        sla.short = 'warning';
      }
    }

    return sla;
  };

  Unit.prototype.health = function () {
    var e_4, _a;

    var comErrorMinAgeMS = 21600000;
    var dataErrorMinAgeMS = 43200000;
    var comWarningMinAgeMS = 3600000;
    var dataWarningMinAgeMS = 14400000;
    var errorFactor = 4;
    var warningFactor = 3;
    var schedulingIntervalMS = this.scheduling && this.scheduling.data && this.scheduling.data.interval ? this.scheduling.data.interval * 1000 : 1800000;
    var comErrorAge = schedulingIntervalMS < comErrorMinAgeMS ? comErrorMinAgeMS : schedulingIntervalMS * errorFactor;
    var dataErrorAge = schedulingIntervalMS < dataErrorMinAgeMS ? dataErrorMinAgeMS : schedulingIntervalMS * errorFactor;
    var comWarningAge = schedulingIntervalMS < comWarningMinAgeMS ? comWarningMinAgeMS : schedulingIntervalMS < 86400000 ? schedulingIntervalMS * warningFactor : schedulingIntervalMS;
    var dataWarningAge = schedulingIntervalMS < dataWarningMinAgeMS ? dataWarningMinAgeMS : schedulingIntervalMS < 86400000 ? schedulingIntervalMS * warningFactor : schedulingIntervalMS; // Communication related

    var comAgeMS = Date.now() - this.lastSeen.getTime();
    var comStatus = health_1.HealthStatusEnum.UNKNOWN;

    if (comAgeMS > comErrorAge) {
      comStatus = health_1.HealthStatusEnum.ERROR;
    } else if (comAgeMS > comWarningAge) {
      comStatus = health_1.HealthStatusEnum.WARNING;
    } else {
      comStatus = health_1.HealthStatusEnum.OK;
    }

    var communication = {
      latest: this.lastSeen,
      expectedRate: schedulingIntervalMS / 1000,
      status: comStatus
    };
    var canHaveReading = this.ports.length > 0;
    var dataStatus = health_1.HealthStatusEnum.UNKNOWN;
    var newest = new Date();

    if (canHaveReading) {
      var newestTime = 0;
      var ignoredPorts_1 = ['/3/', '/7050/', '/7051/', '/ds', '/dev/', '/sys/', '/sen/', '/obis/', '/4/0/ap', '/3303/0/5700', '/3311/'];

      var isIgnored = function isIgnored(portIndex) {
        for (var i = ignoredPorts_1.length - 1; i >= 0; i--) {
          if (portIndex.substr(0, ignoredPorts_1[i].length) === ignoredPorts_1[i]) {
            return true;
          }
        }

        return false;
      };

      var nonIgnoredPorts = 0;

      try {
        for (var _b = __values(this.ports.ports()), _c = _b.next(); !_c.done; _c = _b.next()) {
          var port = _c.value;
          var time = port.time.getTime();

          if (!isIgnored(port.index) && port.readingMethod !== "none" && time > newestTime) {
            newestTime = time;
            newest = port.time;
            nonIgnoredPorts++;
          }
        }
      } catch (e_4_1) {
        e_4 = {
          error: e_4_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_4) throw e_4.error;
        }
      }

      if (nonIgnoredPorts > 0) {
        var dataAgeMS = Date.now() - newestTime;

        if (dataAgeMS > dataErrorAge) {
          dataStatus = health_1.HealthStatusEnum.ERROR;
        } else if (dataAgeMS > dataWarningAge) {
          dataStatus = health_1.HealthStatusEnum.WARNING;
        } else {
          dataStatus = health_1.HealthStatusEnum.OK;
        }
      } else {
        // same as !canHavereading
        var dataAgeMS = Date.now() - this.time.getTime();
        newest = this.time;

        if (dataAgeMS > dataErrorAge) {
          dataStatus = health_1.HealthStatusEnum.UNKNOWN;
        } else if (dataAgeMS > dataWarningAge) {
          dataStatus = health_1.HealthStatusEnum.WARNING;
        } else {
          dataStatus = health_1.HealthStatusEnum.OK;
        }
      }
    } else {
      var dataAgeMS = Date.now() - this.time.getTime();
      newest = this.time;

      if (dataAgeMS > dataErrorAge) {
        dataStatus = health_1.HealthStatusEnum.UNKNOWN;
      } else if (dataAgeMS > dataWarningAge) {
        dataStatus = health_1.HealthStatusEnum.WARNING;
      } else {
        dataStatus = health_1.HealthStatusEnum.OK;
      }
    } // Data related


    var data = {
      latest: newest,
      expectedRate: this.scheduling != null && this.scheduling.data.force ? schedulingIntervalMS / 1000 : schedulingIntervalMS / 1000 * warningFactor,
      status: dataStatus
    };

    if (this.deviceType === DeviceType.Meter) {
      // TODO: use graph for connectivity info
      return {
        communication: data,
        data: data
      };
    }

    return {
      communication: communication,
      data: data
    };
  };

  Unit.prototype.generateInstallAssetID = function (usagePoint) {
    if (usagePoint != null) {
      if (usagePoint.location != null && usagePoint.location.siteid != null && usagePoint.location.siteid === usagePoint.assetid.substr(0, usagePoint.location.siteid.length)) {
        if (this.model.model !== "unknown" && this.model.manufacturer !== "Kamstrup") {
          return usagePoint.assetid + " - " + this.model.model;
        }

        return usagePoint.assetid + " - " + this.model.manufacturer;
      }

      return usagePoint.location.siteid + " " + usagePoint.assetid + " - " + this.model.manufacturer;
    }

    return this.assetid;
  };

  Unit.prototype.generateInstallTags = function (usagePoint) {
    if (usagePoint != null) {
      if (!usagePoint.location.name || usagePoint.location.name === "Unconfigurated" || usagePoint.location.name === "") {
        if (usagePoint.location.areaid != null && usagePoint.location.areaid !== "") {
          if (this.productType() === ProductType.Zodiac) {
            // TODO replace with something using medium
            return usagePoint.location.areaid + ", Electricity";
          }

          return usagePoint.location.areaid;
        } else if (usagePoint.location.siteid != null) {
          if (this.productType() === ProductType.Zodiac) {
            return usagePoint.location.siteid + ", Electricity";
          }

          return usagePoint.location.siteid;
        }
      } else {
        return usagePoint.location.name;
      }
    }

    return this.location.name;
  }; // transform ports into multiports

  /* Persistency related functions */

  /** Tries to load this unit from IndexedDB or whatever is available */


  Unit.prototype.load = function () {
    var _this = this;

    unit_1.load(this.uuid).then(function (res) {
      console.log("Loaded: " + _this.uuid.string() + " from storage");

      if (res != null) {
        _this.merge(res);
      }
    }).catch(function (reason) {
      console.log("No such unit found in storage. Load failed with: " + reason);
    });
  };
  /** Store this unit in IndexedDB or whatever is available */


  Unit.prototype.store = function () {
    unit_1.store(this);
  };
  /* Remote access functions  */

  /** gets the unit with the given fields from the REST API */

  /**
   * Get gets the device from from the API if it exists. This returns a Promise for a Unit or undefined
   * @param fields - Fields is the set of fields used to query the backend
   * @param credentials Credentials holds the authorization credentials for the request
   *
   * @returns
   */


  Unit.prototype.get = function (fields, credentials) {
    var _this = this;

    return unit_2.default(this.uuid, this.lastUpdated, fields, credentials).then(function (resp) {
      var e_5, _a;

      if (resp.length > 1) {
        console.error("Got more than one device when getting a single device from remote with uuid: " + _this.uuid.string());
        console.error(resp);
      }

      try {
        for (var resp_1 = __values(resp), resp_1_1 = resp_1.next(); !resp_1_1.done; resp_1_1 = resp_1.next()) {
          var d = resp_1_1.value;
          var unit_3 = exports.decodeUnit(d);

          _this.replace(unit_3);

          _this.fields = fields; // should we merge these?

          return unit_3;
        }
      } catch (e_5_1) {
        e_5 = {
          error: e_5_1
        };
      } finally {
        try {
          if (resp_1_1 && !resp_1_1.done && (_a = resp_1.return)) _a.call(resp_1);
        } finally {
          if (e_5) throw e_5.error;
        }
      }
    });
  };
  /** create creates the unit for the backend. NOTE: DO NOT CALL THIS ON AN EXISTING UNIT!
   * @param credentials The credentials used to authorize this request with
   * @param manufacturing An optional manufacturing payload if this unit is created along with manufacturing tracking data
  */


  Unit.prototype.create = function (credentials, manufacturing) {
    var _this = this;

    return unit_2.createUnit(this.encode(), credentials, manufacturing).then(function (rawUnit) {
      var retUnit = exports.decodeUnit(rawUnit);
      _this.uuid = retUnit.uuid;
      return retUnit;
    });
  };
  /** getAlert gets alerts for the given unit
   * @param credentials Credentials holds the authorization credentials for the request
   * @param time The time from which alerts need to be newer than
   * @param severity Optional severity parameter, get only alerts from this severity and more severe (defaults to: Info)
   * @param includeResolved Optional boolean parameter to to control if want resolved alerts as well from the API
   * @param includeDismissed Optional boolean parameter to to control if want dismissed alerts as well from the API
   */


  Unit.prototype.getAlerts = function (credentials, time, severity, includeResolved, includeDismissed) {
    var s = alert_1.AlertSeverity.Info;
    var iR = true;
    var iD = true;

    if (severity != null) {
      s = severity;
    }

    if (includeResolved != null) {
      iR = includeResolved;
    }

    if (includeDismissed != null) {
      iD = includeDismissed;
    }

    return alert_2.get(this.uuid, time, s, iR, iD, credentials).then(function (resp) {
      var e_6, _a;

      var ret = [];

      try {
        for (var resp_2 = __values(resp), resp_2_1 = resp_2.next(); !resp_2_1.done; resp_2_1 = resp_2.next()) {
          var d = resp_2_1.value;
          ret.push(alert_1.decodeAlert(d));
        }
      } catch (e_6_1) {
        e_6 = {
          error: e_6_1
        };
      } finally {
        try {
          if (resp_2_1 && !resp_2_1.done && (_a = resp_2.return)) _a.call(resp_2);
        } finally {
          if (e_6) throw e_6.error;
        }
      }

      return ret;
    });
  };
  /** getAlarms gets alerts for the given unit
   * @param credentials Credentials holds the authorization credentials for the request
   * @param time The time from which alerts need to be newer than
   * @param severity Optional severity parameter, get only alerts from this severity and more severe (defaults to: Info)
   * @param onlyOngoing Optional boolean parameter to to control if want resolved alerts as well from the API
   */


  Unit.prototype.getAlarms = function (credentials, time, severity, onlyOngoing) {
    var s = alert_1.AlertSeverity.Info;
    var oG = false;

    if (severity != null) {
      s = severity;
    }

    if (onlyOngoing != null) {
      oG = onlyOngoing;
    }

    return alarm_1.get(time, credentials, this.uuid, onlyOngoing, s).then(function (resp) {
      var e_7, _a;

      var ret = [];

      if (resp === undefined) {
        return ret;
      }

      try {
        for (var resp_3 = __values(resp), resp_3_1 = resp_3.next(); !resp_3_1.done; resp_3_1 = resp_3.next()) {
          var d = resp_3_1.value;
          ret.push(alarm_2.decodeAlarm(d));
        }
      } catch (e_7_1) {
        e_7 = {
          error: e_7_1
        };
      } finally {
        try {
          if (resp_3_1 && !resp_3_1.done && (_a = resp_3.return)) _a.call(resp_3);
        } finally {
          if (e_7) throw e_7.error;
        }
      }

      return ret;
    });
  };

  Unit.prototype.encode = function () {
    var rawUnit = {};

    if (this.uuid.valid() && !this.uuid.equals("00000000-0000-0000-0000-000000000000")) {
      rawUnit["uuid"] = this.uuid.string();
    } else {
      console.log("Unit encoding has no uuid when encoding:", this);
    }

    if (this.assetid != null && this.assetid.length > 0) {
      rawUnit["assetid"] = this.assetid;
    } else {
      console.log("Unit encoding has no assetid when encoding:", this);
    }

    if (this.giai != null && this.giai.length > 0) {
      rawUnit["giai"] = this.giai;
    } else {
      console.log("Unit encoding has no giai when encoding:", this);
    }

    if (this.model != null && this.model.model != null && this.model.model.length > 0) {
      rawUnit["model"] = this.model.model;
    } else {
      console.log("Unit encoding has no model string when encoding:", this);
    }

    if (this.version != null && this.version.length > 0) {
      rawUnit["version"] = this.version;
    } else {
      console.log("Unit encoding has no version when encoding:", this);
    }

    if (this.channel != null && this.channel.length > 0) {
      rawUnit["channel"] = this.channel;
    } else {
      console.log("Unit encoding has no channel when encoding:", this);
    }

    if (this.profile > 0) {
      rawUnit["profile"] = this.profile;
    }

    if (this.profileVersion > 0) {
      rawUnit["profileversion"] = this.profileVersion;
    }

    if (this.deviceType) {
      rawUnit["deviceType"] = this.deviceType;
    }

    if (this.location != null && Object.keys(this.location.encode()).length !== 0) {
      rawUnit["location"] = this.location.encode();
    }

    if (this.meters.length > 0 && Object.keys(this.meters[0].encode()).length !== 0) {
      rawUnit["meter"] = this.meters[0].encode();
    }

    if (this.modem != null && Object.keys(this.modem.encode()).length !== 0) {
      rawUnit["modem"] = this.modem.encode();
    }

    if (this.model != null && this.model.manufacturer !== "") {
      rawUnit["model2"] = this.model.encode();
    }

    if (this.scheduling != null && this.scheduling.method !== 0) {
      rawUnit["scheduling"] = this.scheduling;
    }

    return JSON.parse(JSON.stringify(rawUnit));
  };
  /* Support functions */

  /** Merges inputted unit with this unit in an as safe as possible manner */


  Unit.prototype.merge = function (u) {
    if (!this.uuid.equals(u.uuid)) {
      throw Error("Merge called with mismatching unit. " + u.uuid.string() + " tried to merge with " + this.uuid.string());
    }

    this.assetid = u.assetid;
    this.giai = u.giai;
    this.model = u.model;
    this.version = u.version;
    this.channel = u.channel;
    this.time = u.time;
    this.lastSeen = u.lastSeen;
    this.profile = u.profile;
    this.profileVersion = u.profileVersion;
    this.deviceType = u.deviceType;
    this.lastUpdated = u.lastUpdated; //status

    this.status = u.status;
    this.lifecycle = u.lifecycle;
    this.location = u.location;
    this.meters = u.meters;
    this.modem = u.modem;
    this.connections = u.connections;
    this.configurations = u.configurations;
    this.ports = u.ports; // sort?

    this.weather = u.weather;
    this.connectable = u.connectable;
    this.scheduling = u.scheduling;
    this.fields = u.fields; // perhaps?

    this.workorders = u.workorders;
  };

  return Unit;
}();

exports.Unit = Unit; // load(fields) use local if has fields, otherwise use remote

exports.default = Unit;